module.exports = __webpack_public_path__ + "img/sign-30.3412dfc6.jpg";